import React, { useEffect, useState } from 'react';
import { sectionedPanelStyle } from '../../../../styles';
import { dummy_data } from './dummy_data';
import { AsButton } from '@adserve/adserve-react-components';
import PerformanceByTimeTable from './PerformanceByTimeTable/PerformanceByTimeTable';
import OverAllPerformance from '../BreakdownFigures/OverAllPerformance';

const PerformanceByTimeBlock = ({ id = 'PerformanceByTimeBlock', showDetail, deliveryTable, data }) => {
    const titleStyle = {
        fontFamily: 'Roboto',
        fontSize: 17,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    };

    // ASSP-7703 clarify tabulation
    const title = showDetail
                    ? window.translate('Performance by Daypart - Selected Dayparts')
                    : window.translate('Performance by Daypart - All Dayparts');
    
    return (
        <div
            id={id}
            style={{
                ...sectionedPanelStyle,
                padding: '18px 18px 10px',
                height: 376,
                boxSizing: 'border-box',
                width: '100%'
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={titleStyle}>{title}</span>
            </div>

            <div style={{ marginTop: 12 }}> {/* ASSP-7703 was 20 */}
                {showDetail ? <OverAllPerformance data={deliveryTable} /> : <PerformanceByTimeTable data={data} />}
            </div>
        </div>
    );
};

export default PerformanceByTimeBlock;
